/**
 * @generated SignedSource<<cdf2e4289793de6dc9dabd0d61b83be9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PlainTextCellOld435BadPattern$data = {
  readonly id?: string;
  readonly text: string | null | undefined;
  readonly " $fragmentType": "PlainTextCellOld435BadPattern";
};
export type PlainTextCellOld435BadPattern$key = {
  readonly " $data"?: PlainTextCellOld435BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlainTextCellOld435BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "PlainTextCellOld435BadPattern",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "text"
    }
  ],
  "type": "JiraSingleLineTextField"
};

(node as any).hash = "eb05c46c1e01b2f786b791521952c328";

export default node;
